module.exports = {
  appId: process.env.REACT_APP_APP_ID,
  redirectUri: process.env.REACT_APP_REDIRECT_URI,
  scopes: ["user.read"],
};
